module.exports = {
  checkbox: {
    show_select_all: 0, // 是否显示全选
    select_max: 0,  // 最多选择
    select_min: 0 // 最小选择
  },
  checkbox_option: []
}



// WEBPACK FOOTER //
// ./src/components/Model/widgetAttr/checkbox.js